/**
 * Qinggong teachers in person (docs/archive/QINGGONG.md §7): the people who teach an art in their zone
 * (data/qinggong.ts `QINGGONG_TEACHERS`) stand at their landmark, and talking to one tells what they
 * teach. Learning itself still goes through the qinggong tab while in the teacher's zone
 * (`qinggongLearn`), as before: the teacher is a face for it, not a new rule.
 */
import { QINGGONG_TEACHERS, type QinggongTeacher } from '../data/qinggong';
import type { Entity } from '../world';
import type { SystemHost, WorldSystem } from './types';

export class TeachersSystem implements WorldSystem {
  readonly name = 'teachers';
  private readonly here = new Map<number, QinggongTeacher>();

  constructor(private readonly h: SystemHost) {}

  setup(): void {
    const m = this.h.world.map;
    for (const t of QINGGONG_TEACHERS) {
      const at = t.zone === m.zone ? m.landmarks?.[t.at] : undefined;
      if (!at) continue;
      const e = this.h.add({
        kind: 'npc',
        x: at.x + (t.dx ?? 0),
        y: at.y + (t.dy ?? 0),
        sprite: t.sprite,
        name: t.name,
        title: t.title,
        facing: t.facing ?? 1,
      });
      this.here.set(e.id, t);
    }
  }

  talk(npc: Entity): boolean {
    const t = this.here.get(npc.id);
    if (!t) return false;
    this.h.emit({ type: 'dialog', npcId: npc.id, text: t.text, action: null });
    return true;
  }
}
